// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"cf384db0","285":"c56eadac","893":"d8854fab"}[chunkId] + ".chunk.js";
};